import { render } from "./PointDetail.vue?vue&type=template&id=0540aa0d"
import script from "./PointDetail.vue?vue&type=script&lang=js"
export * from "./PointDetail.vue?vue&type=script&lang=js"

import exportComponent from "/builds/benoit67/django-business-center-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__